export default {

  // Set it all up when a vehicle is selected
  calculatorSetup() {
    // Setup fuel costs

    electricFuelCost = {
      'annual-cost-miles': 0,
      'cost-per-mile': 0,
      'annual-cost-hours': 0,
      'cost-per-hour': 0,
    }

    // if sessionStorage item exists, use those values
    sessionStorage.setItem('electricFuelCost', JSON.stringify(electricFuelCost))

    // Setup equipment costs

    // Setup other costs

  },
  


  
  //Electric
  //---
  calculateFuelCostElectric() {

  },
  calculateEquipmentCostElectric() {},
  calculateOtherCostElectric() {},
  
  
  
  //Diesel
  //---
  calculateFuelCostDiesel() {},
  calculateEquipmentCostDiesel() {},
  calculateOtherCostDiesel() {},


  // Global updates so we inject right into the vehicle objects
  updateMileage(mileage) {
    // Update both objects with new mileage
    let globalElectric = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
    let globalDiesel = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
    
    globalElectric.fuel.mileage = Number(mileage)
    globalDiesel.fuel.mileage = Number(mileage)

    // Reset objects
    localStorage.setItem('calculatorVehicleElectric', JSON.stringify(globalElectric))
    localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(globalDiesel))
  },
  updateHours(hours) {
    // Update both objects with new mileage
    let globalElectric = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
    let globalDiesel = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
    
    globalElectric.fuel.hours = Number(hours)
    globalDiesel.fuel.hours = Number(hours)

    // Reset objects
    localStorage.setItem('calculatorVehicleElectric', JSON.stringify(globalElectric))
    localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(globalDiesel))
  }
    
}